<template>
  <div id="app">
    <loading
      :active.sync="isLoading"
      :color="loaderColor"
      :loader="loaderType"
    ></loading>

    <Header />

    <router-view />
    <Footer />
    <!-- <FooterBar /> -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/Header/Header.vue";
import Footer from "./components/Footer/Footer.vue";
// import FooterBar from "./components/FloatingFooter/FooterBar";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import { LocationId } from "./services/storage.service";

import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";

Vue.use(Autocomplete);

// Init plugin
Vue.use(Loading);

export default {
  name: "App",
  data() {
    return {
      isLoading: 0,
      loaderType: "dots",
      loaderColor: "green",
      scrollValue: -1,
      loc_id: LocationId.getLocationId(),
    };
  },
  components: {
    Footer,
    Loading,
    Header,
    // FooterBar,
  },
  beforeCreate() {},
  created() {
    window.scrollTo(0, 0);
    this.megamenu(this.loc_id);
  },
  watch: {
    authenticating: function (val) {
      this.isLoading = val;
    },
    popOrderConfirm: function (val) {
      if (val) {
        this.$notification.success({
          message: "Order Recieved",
          description:
            "We got your order! We will call you back to confirm your order.",
        });
        setTimeout(this.confirmOrderChange, 3000);
      } else {
        return;
      }
    },
    ordering: function (val) {
      this.isLoading = val;
    },

    scrollValue: function (n, o) {
      if (n > o) {
        //Scroll Down
        this.scrollingDown = 1;
      } else if (n < o) {
        //Scroll Up
        this.scrollingDown = 0;
      }
    },
  },
  computed: {
    ...mapGetters([
      "authenticating",
      "ordering",
      "cartItems",
      "popOrderConfirm",
    ]),
  },
  created() {
    // window.addEventListener("resize", this.handleWindowResize);
    // this.handleWindowResize();
    this.megamenu(LocationId.getLocationId());
  },
  destroyed() {
    // window.removeEventListener("resize", this.handleWindowResize);
  },
  methods: {
    ...mapActions(["confirmOrderChange", "megamenu"]),

    // handleWindowResize() {
    //   // console.log(window.innerHeight, window.innerWidth);
    // },
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
@import "@/styles/layout.scss";
@import "@/styles/global.scss";

@import "@/styles/responsive.scss";
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.ant-select-auto-complete.ant-select .ant-input {
  height: 45px;
  background-color: #f1f1f1 !important;
  outline: none;
  border: none;
  // border: 1px solid black;
}

body {
  font-family: $main-font;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.4;
}
section {
  padding: 80px 0;
}

@media only screen and (max-width: 991px) {
  section {
    padding: 50px 0;
  }
}

@media only screen and (max-width: 767px) {
  section {
    padding: 40px 0;
  }
}

@media only screen and (max-width: 575px) {
  section {
    padding: 30px 0;
  }
}

@font-face {
  font-family: "Stay-Classy-SLDT";
  src: local("Stay-Classy-SLDT"),
    url(./assets/fonts/Stay-Classy-SLDT.ttf) format("truetype");
}

@font-face {
  font-family: "American-Lemon";
  src: local("American-Lemon"),
    url(./assets/fonts/American-Lemon.otf) format("opentype");
}
</style>
